module.exports = __webpack_public_path__ + "static/real-time-monitoring-cc2f19674653fee7067bf339aa492d0d.svg";